import request from '@/axios'
import { desEncrypt, DES_DEFAULT_KEY } from '@/utils/encrypt.js'

const { WEBPACK_ENV } = process.env
import { ENV_CONFIG } from '../config/config.js'
/**
 * 授权码登录
 * @param data
 * @returns
 */
export function login(data) {
  return request({
    url: '/inside/ai/chatbot/login',
    data
  })
}

/**
 * 短信验证码登录
 * @param data
 * @returns
 */
export function loginWithSms(data) {
  return request({
    url: '/aiBot/login/app/withSms',
    data
  })
}
/**
 * 手机号密码登录
 * @param data
 * @returns
 */
export function loginWithPwd({ password, ...rest }) {
  const data = {
    ...rest,
    password: desEncrypt(password, DES_DEFAULT_KEY)
  }
  return request({
    url: '/aiBot/login/app/withPwd',
    data
  })
}

/**
 * 飞书登录
 * @param data
 * @returns
 */
export function larkAuthWebLogin(data) {
  return request({
    url: '/third/lark/authLogin',
    data
  })
}

// 获取图形验证码
export function reqGet(data) {
  return request({
    url: '/login/xbbAppV3/captcha/get',
    data
  })
}

// 校验图形验证码，成功后发送短信
export function sendSms(data) {
  return request({
    url: '/aiBot/login/app/sendSms',
    data
  })
}

// 获取公司列表
export function fetchCompanyList(data) {
  return request({
    url: '/ai/login/xbbAppV3/company/list',
    data
  })
}

// 登录之后获取公司信息
export function checkPackage(data) {
  return request({
    url: '/aiBot/login/app/company/checkPackage',
    data
  })
}

// 检查版本号
export function checkVersion(data) {
  return request({
    url: '/app/version/check',
    data,
    baseURL: ENV_CONFIG[WEBPACK_ENV]?.GATEWAY_URL || 'https://appgateway.xbongbong.com'
  })
}

// 刷新token
export function getRefreshAccessToken(data) {
  return request({
    url: '/inside/ai/chatbot/getRefreshAccessToken',
    data
  })
}

// 获取企信url
export function getAuthUrl(data) {
  return request({
    url: '/inside/ai/getAuthUrl',
    data
  })
}

// 获取授权码
export function getCode(data) {
  return request({
    url: '/inside/ai/getCode',
    data
  })
}
